const widgets = {
    namespaced: true,
    state: {
        grids: null,
        widget: null,
    },
    mutations: {
        updateRefs(state, payload){
            state.grids = payload;
        },
        resetState(state){
        }
    },
    actions: {
        
    },
    getters: {

    }
}

export default widgets;